<template>
  <SideMenu
    ref="sideMenu"
    :heading="$lang('product_page', 'select_size_action')"
    :side="'right'"
    @on-side-menu-close="$emit('onSizeGuideClose')"
  >
    <div class="bg-main h-full flex flex-col">
      <div class="md:px-24 px-16 pt-28 overflow-y-auto mb-80">
        <div class="mb-24">
          <div
            class="wysiwyg wysiwyg--sm mb-24"
            v-html="sizeInformationText"
          />
          <table v-if="product.measurementChart" class="text-xs uppercase">
            <thead>
              <th class="pr-40">
                {{ $lang('product_listing', 'size_filter') }}
              </th>
              <th v-for="head in product.measurementChart.x" :key="head.id">
                {{ head }}
              </th>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in product.measurementChart.y"
                :key="row.id"
                class="pr-40"
              >
                <td>{{ row }}</td>
                <td
                  v-for="data in filteredMeasurementData(index)"
                  :key="data.id"
                  class="text-center px-8 py-2"
                >
                  {{ data.content }}
                </td>
              </tr>
              <tr>
                <td class="text-left">({{ product.measurementChart.unit }})</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </SideMenu>
</template>

<script lang="ts">
import SideMenu, { type SideMenuInterface } from '~/components/navigation/SideMenu.vue';
import Product from '~/models/product';

import { defineComponent } from 'vue';
export default defineComponent({
  components: {
    SideMenu,
  },
  props: {
    product: {
      type: Product,
      required: true,
    },
  },
  computed: {
    sizeInformationText(): string {
      return this.$accessor('config', 'sizeInformation');
    },
  },
  mounted() {
    this.toggleSideMenu();
  },
  methods: {
    filteredMeasurementData(index: number) {
      if (this.product.measurementChart) {
        const data = this.product.measurementChart.contents.filter(
          (data) => data.y === index
        );
        return data;
      }
    },
    toggleSideMenu() {
      const sideMenu = this.$refs.sideMenu as SideMenuInterface;
      sideMenu.openOverlay();
    },
  },
});
</script>
